import { render, staticRenderFns } from "./EditWelEhotelBtn.vue?vue&type=template&id=4c94518c&scoped=true"
import script from "./EditWelEhotelBtn.vue?vue&type=script&lang=js"
export * from "./EditWelEhotelBtn.vue?vue&type=script&lang=js"
import style0 from "./EditWelEhotelBtn.vue?vue&type=style&index=0&id=4c94518c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c94518c",
  null
  
)

export default component.exports